if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form.querySelector("[name=id]").disabled = false;
                this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
                this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
                this.submitButton = this.querySelector('[type="submit"]');
                if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute("aria-disabled") === "true") return;

                this.handleErrorMessage();

                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];

                const formData = new FormData(this.form);
                if (this.cart) {
                    formData.append(
                        "sections",
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append("sections_url", window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute("aria-disabled", true);
                            this.submitButton.querySelector("span").classList.add("hidden");
                            soldOutMessage.classList.remove("hidden");
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        this.error = false;
                        const quickAddModal = this.closest("quick-add-modal");
                        if (quickAddModal) {
                            document.body.addEventListener(
                                "modalClosed",
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(response);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove("loading");
                        if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
                        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
                        setTimeout(() => {
                            if (this.cart) this.cart.close();
                        }, Number(this.cart.dataset.timeout));
                    });
            }

            handleErrorMessage(errorMessage = false) {
                this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

                this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}

if (!customElements.get("slider-product")) {
    customElements.define(
        "slider-product",
        class ProductSlide extends HTMLElement {
            constructor() {
                super();
                this.main = this.querySelector(".js-main-media");
                this.thumb = this.querySelector(".js-thumb-media") || null;
                this.nextBtn = this.querySelector(".slider-button--next") || null;
                this.prevBtn = this.querySelector(".slider-button--prev") || null;
                this.pagi = this.querySelector(".swiper-pagination") || null;
                // this.thumbViews = Number(this.dataset.thumbViews) || 5;
                this.thumbViews = "auto";
                this.loop = this.hasAttribute("data-loop");
                this.zoom = this.hasAttribute("data-zoom");
                this.autoHeight = this.hasAttribute("data-auto-height");
                this.autoPlay = this.hasAttribute("data-auto-play")
                    ? {
                          delay: Number(this.dataset.time ? this.dataset.time : 3) * 1000,
                      }
                    : false;
                    this.main && this.initSlider();
            }
            connectedCallback() {
            }
            initSlider() {
                if (this.thumb) {
                    this.swiperThumb = new Swiper(this.thumb, {
                        // loop: true,
                        spaceBetween: 12,
                        slidesPerView: this.thumbViews,
                        watchOverflow: true,
                        centerInsufficientSlides: true,
                        // freeMode: true,
                        // watchSlidesProgress: true,
                    });
                }

                let optionMain = {
                    loop: this.loop,
                    spaceBetween: 10,
                    autoplay: this.autoPlay,
                    autoHeight: this.autoHeight,
                    zoom: this.zoom,
                    on: {
                        slideChange: (e) => {
                            window.pauseAllMedia();
                        },
                        init: function (e) {
                            if (this.el.querySelector(".swiper-slide-active video")) {
                                this.el.querySelector(".swiper-slide-active video").play();
                            }
                        },
                    },
                };

                if (this.pagi) {
                    optionMain.pagination = {
                        el: this.pagi,
                        clickable: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 3,
                    };
                }
                if (this.nextBtn && this.prevBtn) {
                    optionMain.navigation = {
                        nextEl: this.nextBtn,
                        prevEl: this.prevBtn,
                    };
                }
                if (this.swiperThumb) {
                    optionMain.thumbs = {
                        swiper: this.swiperThumb,
                    };
                }

                this.swiperMain = new Swiper(this.main, optionMain);

                function playPauseVideo(swiper, control) {
                    let currentSlide, video;
                    currentSlide = swiper.querySelector(".swiper-slide-active");
                    video = currentSlide && currentSlide.querySelector("video");

                    if (video) {
                        if (control == "play") {
                            video.play();
                        } else {
                            video.pause();
                        }
                    }
                }

                this.swiperMain.on("slideChange", function (e) {
                    playPauseVideo(this.$el[0], "pause");
                });
                this.swiperMain.on("slideChangeTransitionEnd", function (e) {
                    playPauseVideo(this.$el[0], "play");
                });
            }
            slideTo(index) {
                let checkIndex = Number(index) || 0;
                this.swiperMain.slideTo(checkIndex + 1, 0);
            }
        }
    );
}

